export const AUTHENTICATED_USER_KEY = 'k'
export const ACCOUNT_KEY = 'FIELD_CONTROL_ACCOUNT'
export const FLAGS_KEY = 'FLAGS'
